module.exports = __webpack_public_path__ + "img/React-LunarPhase-desktop.cc5030dc.png";